import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import Form from '@nubank/nuds-web/components/Form/Form';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import { useBreakpointsMediaUp, breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

import Image from '@nubank/www-latam-commons/components/Image/Image';

import { redirectionEvent } from '../../tracking';

import StoresButtons from './StoresButtons';

const StyledTitle = styled(Typography)`
   ${breakpointsMedia({
    xs: css`
      font-size: 32px;
  `,
    md: css`
      font-size: 38px;
  `,
  })}
`;

const Subtitle = styled(Typography)`
   ${breakpointsMedia({
    xs: css`
      font-size: 16px;
  `,
    md: css`
      font-size: 20px;
  `,
  })}
`;

// Update styled component for the divider
const Divider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  padding: 25px 90px;
  font-weight: 900;
 
&::before, &::after {
  content: '';
  flex: 1;
  border-bottom: 2px solid #B8B8B8;
}

&:not(:empty)::before {
  margin-right: 2rem;
}

&:not(:empty)::after {
  margin-left: 2rem;
}
  
`;

function AppRedirection() {
  useEffect(() => {
    redirectionEvent('display-web2app-download');
  }, []);

  return (
    <Form.Step>
      {() => (
        <Box minHeight="100%">
          <Box
            overflowY="auto"
            marginTop="-40px"
            paddingBottom="4x"
          >

            {/* TITLE AND SUBTITLE */}
            <Box paddingHorizontal={{ xs: '24px', md: '40px' }}>
              <StyledTitle variant="heading2" marginTop="8x">
                ¡Vamos bien!
                <StyledTitle tag="span" variant="heading2" color="primary">
                  {' '}
                  Continúa tu registro en la app
                </StyledTitle>
              </StyledTitle>
              {
              useBreakpointsMediaUp('md') ? (
                <Subtitle variant="paragraph1" marginTop="6x">
                  <Subtitle tag="span" variant="paragraph1" strong>
                    Descárgala al escanear este código
                  </Subtitle>
                  {' '}
                  para terminar tu solicitud y
                  {' '}
                  <Subtitle tag="span" variant="paragraph1" strong>
                    conocer tu oferta personalizada.
                  </Subtitle>
                </Subtitle>
              ) : (
                <Subtitle variant="paragraph1" marginTop="6x">
                  <Subtitle tag="span" variant="paragraph1" strong>
                    Descárgala
                  </Subtitle>
                  {' '}
                  para terminar tu solicitud y
                  {' '}
                  <Subtitle tag="span" variant="paragraph1" strong>
                    conocer tu oferta personalizada.
                  </Subtitle>
                </Subtitle>
              )
            }
            </Box>

            {/* IMAGE / QR */}
            {
              useBreakpointsMediaUp('md') ? (
                <>
                  <Box
                    marginTop={{ xs: '18x' }}
                    marginBottom={{ xs: '-25px', md: '8x' }}
                    display="flex"
                    justifyContent="center"
                  >
                    <Image
                      src="data-mismatch/qr-to-app-v1.svg"
                      alt="Imagen de un códifgo QR para descargar la app"
                      webp={false}
                      width="260px"
                      height="auto"
                    />
                  </Box>
                  <Divider> o </Divider>
                </>
              ) : (
                <Box
                  marginTop={{ xs: '6x' }}
                  marginBottom={{ xs: '-25px', lg: '8x' }}
                >
                  <Image
                    src="data-mismatch/four-cards.svg"
                    alt="Imagen de cuatro tarjetas de crédito"
                    webp={false}
                    width="100vw"
                    height="auto"
                  />

                </Box>
              )
            }

            {/* BUTTONS */}
            <Box
              marginBottom="4x"
              paddingHorizontal={{ xs: '24px', lg: '40px' }}
            >
              <StoresButtons
                link="https://link.nubank.com.br/web-to-app-v1"
              />

            </Box>
          </Box>
        </Box>
      )}
    </Form.Step>

  );
}

export default AppRedirection;
